// extracted by mini-css-extract-plugin
export default {"fullscreen":"d2O6uSzf6IoC00KXmdA6","center":"dyOD0I29U40eXhrt7Auy"};